import _regeneratorRuntime from "babel-runtime/regenerator";

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from "react";
import PropTypes from "prop-types";
import { DragSource } from "react-dnd";
import { getEmptyImage } from "react-dnd-html5-backend";
import { Close } from "../../../Misc/Icons";

var GraphicAsset = function (_React$Component) {
  _inherits(GraphicAsset, _React$Component);

  function GraphicAsset() {
    _classCallCheck(this, GraphicAsset);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  GraphicAsset.prototype.componentDidMount = function componentDidMount() {
    var connectDragPreview = this.props.connectDragPreview;

    if (connectDragPreview) {
      connectDragPreview(getEmptyImage(), {
        captureDraggingState: true
      });
    }
  };

  GraphicAsset.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        asset = _props.asset,
        connectDragSource = _props.connectDragSource,
        isDragging = _props.isDragging;
    var url = asset.url,
        title = asset.title;
    var opacity = isDragging ? 0.4 : 1;
    return connectDragSource(React.createElement("div", {
      className: "recorder__gallery-item"
    }, this.props.onDelete && React.createElement("a", {
      className: "close",
      onClick: function () {
        var _ref = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee(e) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  e.preventDefault();
                  _context.next = 3;
                  return _this2.props.onDelete(asset);

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()
    }, React.createElement(Close, null)), React.createElement("img", {
      ref: function ref(node) {
        return _this2.image = node;
      },
      src: url,
      title: title,
      alt: title,
      style: {
        opacity: opacity
      }
    })));
  };

  return GraphicAsset;
}(React.Component);

GraphicAsset.propTypes = process.env.NODE_ENV !== "production" ? {
  asset: PropTypes.shape({
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
  }),
  onBeginDrag: PropTypes.func.isRequired,
  connectDragSource: PropTypes.func.isRequired,
  onDelete: PropTypes.func
} : {};
var spec = {
  beginDrag: function beginDrag(props, monitor, component) {
    props.onBeginDrag();
    return {
      url: props.asset.url,
      width: component.image.naturalWidth,
      height: component.image.naturalHeight
    };
  }
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
  };
}

export default DragSource("GraphicAsset", spec, collect)(GraphicAsset);